import { Component } from "@angular/core";
import { INotification } from "@apiserver-rest/ponder-data-client-base";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { NavigationService } from "@ponder-core/navigation/navigation.service";
import { NotificationBubbleComponent } from "@ponder-core/notifications/notification-bubble.component";
import { NotificationService } from "@ponder-core/notifications/notification.service";
import { AvatarComponent } from "@ponder-shared/components/avatar.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { Subscription } from "rxjs";

@Component({
    selector: "header-tools",
    imports: [AvatarComponent, NotificationBubbleComponent],
    templateUrl: "./header-tools.component.html"
})
export class HeaderToolsComponent {
    public readonly profileIconSvg = SvgIconMap.get(SvgIcon.Profile)!;

    public username?: string;
    public hasNotifications: boolean = false;

    private notificationSub!: Subscription;

    constructor(private auth: AuthService, private events: EventBroker, private navigation: NavigationService, private notifications: NotificationService) { 
        this.notificationSub = this.events.ui.onNotificationsUpdated.subscribe(() => {
            this.updateNotificationsBubble();
        });
    }

    public ngOnDestroy(): void {
        this.notificationSub?.unsubscribe();
    }

    public ngOnInit() {
        this.auth.getSessionAsync().then((session: AuthSession | undefined) => {
            if (session?.username) {
                this.username = session.username;
                this.updateNotificationsBubble();
            }
        });
    }

    public onProfileIconClicked() {
        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession) {
                this.events.ui.displaySidebarEvent.emit();
            } else {
                this.navigation.gotoLogin();
            }
        });
    }

    private updateNotificationsBubble(): void {
        if (!this.username) {
            return;
        }

        this.notifications.getNotifications().then((notifications: INotification[]) => {
            this.notifications.getUserNotificationCount().then((count: number) => {
                this.hasNotifications = count > 0;
            });
        });
    }
}
